import { render } from "./HeroiconsSolidArrowCircleLeft.vue?vue&type=template&id=82cff8be"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowCircleLeft.vue"]])

export default __exports__